import { useCallback } from 'react'
import { useAppData } from '../context/AppDataContext'
import { useToast } from '../context/ToastContext'
import { DONE_STATUS, type TaskStatus } from '../data/types'

/**
 * The tick beside a piece on a list: done, or back to editing.
 *
 * Marking something done offers Undo for a few seconds, which puts it back
 * where it was — the same as the board and the task cards. The plain ticks on
 * Today and a person's page had none, so a wrong tap there meant finding the
 * piece again to put it right.
 */
export function useTickDone() {
  const { setTaskStatus } = useAppData()
  const { showToast } = useToast()
  return useCallback(
    (t: { id: string; title: string; status: TaskStatus }) => {
      const was = t.status
      const next: TaskStatus = was === DONE_STATUS ? 'Editing' : DONE_STATUS
      void setTaskStatus(t.id, next)
      if (next === DONE_STATUS) {
        showToast(`"${t.title}" is done.`, 'success', { undo: () => setTaskStatus(t.id, was) })
      }
    },
    [setTaskStatus, showToast],
  )
}
